<template>
  <div class="popup">
    <div class="form popup__content">
      <div class="form__row--center">
        <h2 class="modal__head">{{uploadResultText}}</h2>
      </div>

      <div v-if="!uploadResultText">
        <div class="form__row">
          <div class="form__input-box">
            <label class="form__label">Local path</label>
            <input
              type="text"
              class="form__input"
              v-model="localPath"
              name="localPath"
              placeholder="eg. assets/png"
              v-input-trim
            >
          </div>
        </div>

        <div class="form__row">
          <div class="form__input-box">
            <label class="form__label">Upload file</label>

            <input
              type="file"
              :class="{'form__input': true, 'is-error': errors.has('file')}"
              v-validate="'required'"
              multiple
              ref="fileInput"
              name="file"
              @change="processFile($event)"
            >
            <span class="form__error" v-show="errors.has('file')">{{ errors.first('file') }}</span>
          </div>
        </div>
      </div>

      <div class="form__row popup__btns-row">
        <button class="ark-btn ark-btn--default" @click="$emit('close')">
          {{uploadResultText ? 'Close' : 'Cancel'}}
        </button>

        <button v-if="!uploadResultText" class="ark-btn ark-btn--danger create-user-popup__create-btn" @click="upload">
          <Loader v-if="isUploadFilesInProgress"></Loader>
          <span v-else>Upload</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import config from '../../../config'
  import Loader from '../../Loader/Loader.vue'

  export default {
    name: 'UploadFilesPopup',
    props: ['chosenArenas'],
    components: {Loader},
    data () {
      return {
        localPath: '',
        files: [],
        isUploadFilesInProgress: false,
        uploadResultText: ''
      }
    },
    methods: {
      processFile: function (e) {
        this.files = e.target.files
      },
      upload: function () {
        this.uploadResultText = ''
        this.$validator.validateAll().then((isValid) => {
          if (isValid) {
            let model = this.chosenArenas.map((arena) => {
              return arena.domain
            })

            const formData = new FormData()
            const textData = JSON.stringify(model)
            formData.append('arenas', textData)
            Array.prototype.forEach.call(this.files, file => {
              formData.append(file.name, file)
            })

            this.$http.put(`${config.apiUrl}/arena/files/update?assetLocalPath=${this.localPath}`, formData)
              .then(response => {
                this.isUploadFilesInProgress = false
                this.uploadResultText = 'Upload files complete.'
              }, error => {
                console.log(error)
                this.isUploadFilesInProgress = false
              })
          }
        })
      }
    }
  }
</script>

<style scoped src="./UploadFilesPopup.scss" lang="scss"></style>
